var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.getIkoClass(_vm.currentItem[_vm.variableColor]),attrs:{"title":_vm.getIkoText(_vm.currentItem[_vm.variableColor])}},[(_vm.currentItem[_vm.variableValue] != null)?[_vm._v(" "+_vm._s(_vm.currentItem[_vm.variableValue])+" ")]:[_c('span',{staticClass:"color-transparent"},[_vm._v("-")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }